import React from "react";
import styled, { css } from "styled-components";
import PushStyles from "../../../helpers/PushStyles";
var IconArrowSvg = function IconArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "m7.406 10.784-5.16-4.526a.675.675 0 0 1 0-1.042.926.926 0 0 1 1.189 0L8 9.22l4.565-4.005a.926.926 0 0 1 1.189 0 .675.675 0 0 1 0 1.042l-5.16 4.526A.9.9 0 0 1 8 11a.901.901 0 0 1-.594-.216Z"
  }));
};
IconArrowSvg.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import isObject from "../../../utils/isObject";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import AnimateHeightOrg from "../../organisms/AnimateHeightOrg";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
export var getPaddingStyles = function getPaddingStyles(pushSpace) {
  return css(["", " ", ""], typeof pushSpace === "number" && css(["padding:", ";"], space(pushSpace)), isObject(pushSpace) && css(["", ";"], PushStyles(pushSpace, true, "space", "padding")));
};
export var Wrapper = styled.div.withConfig({
  componentId: "sc-113fur5-0"
})(function (_ref) {
  var $background = _ref.$background,
    $pushSpace = _ref.$pushSpace,
    $colorEmphasis = _ref.$colorEmphasis,
    theme = _ref.theme;
  return css(["", " border-radius:", ";background-color:", ";cursor:pointer;"], $pushSpace && getPaddingStyles($pushSpace), getBorderRadius(theme, "large"), getColor(theme, $background, "default", $colorEmphasis));
});
export var IconArrow = styled(IconArrowSvg).withConfig({
  componentId: "sc-113fur5-1"
})(function (_ref2) {
  var $isOpen = _ref2.$isOpen,
    $background = _ref2.$background,
    theme = _ref2.theme;
  return css(["", ";.icon{", ";fill:", ";}", ""], transition("transform"), transition("fill"), getIconColor(theme, $background, "high"), $isOpen && css(["transform:rotate(-180deg);"]));
});
export var ContentWrapper = styled(FlexContainerOrg).withConfig({
  componentId: "sc-113fur5-2"
})(["width:100%;"]);
export var TextWrapper = styled(AnimateHeightOrg).withConfig({
  componentId: "sc-113fur5-3"
})(["padding-top:", ";"], space(0.5));